export default __webpack_public_path__ + "static/media/logo1.7060c51b.png";